/* eslint-disable max-lines */

interface ProductImageSet {
  /** Ingredients label */
  label0: string;
  /** Main image */
  label1: string;
  /** Main image with pills */
  label2: string;
  /** Main image with US news badge */
  label3?: string;
  /** Main image with US news badge and pills */
  label4?: string;
  /** Main image with alt badge */
  label5?: string;
  /** Main image with alt badge and pills */
  label6?: string;
  /** Main image with NSF badge*/
  label7?: string;
  /** Main image with NSF badge and pills*/
  label8?: string;
}

export const PRODUCT_IMAGES_CORE: Record<string, ProductImageSet> = {
  MENPRO1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GMRwIuDhdHgDUXeEIKA6k/806e421ca4adf50496456de0abd97673/label-men-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1rFsoiTYFiofRu0K6i1tCq/e97ac6bfaa50a49bdd51ab4a73252369/product-men.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/NP4VXw6tvIpDbJCPRyOBR/2822ed5c9562059235cc8239827253f2/product-men-pills.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3UhOk6vrfJE0AEKgrlVxo3/4bec0283bca92113c445507f2c599921/MENPRO1_5.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4JYrSRyIgdzBVBbDBp9oYQ/e3e721631f1ebbb2e8f2970b68dca22a/men-pills-badge-usnews.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/NP4VXw6tvIpDbJCPRyOBR/2822ed5c9562059235cc8239827253f2/product-men-pills.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/46ADMgCGpf3Sh4YeFWH5lU/66d8c376821346e68d97117594b622e5/men-badge-pills.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/XP9Ce1utiLYb3gPNMIYuc/69c53ab0023b4444cf5e1ccb4e234c15/MENPRO1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/WKVzvr5chwUG6KR3xUAwn/d35e3816261c9b3ce68425e112d5e801/men-nsf-badge-pills.png",
  },
  MENPRO3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GMRwIuDhdHgDUXeEIKA6k/806e421ca4adf50496456de0abd97673/label-men-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/i9BFDrbSutRtQ4aDzIKGf/3657d4cd1ae2a105e65219a0ea604faa/MENPRO3_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6RyBeywd12Pj0jqBtsECA5/b439406142d3c54a2149ee7f01d9eea4/MEN3_3.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/Ty7t4ovbOCiqRR28Z3uk4/26ee404c7f84aecb7a30b4f1ffbcecb8/MENPRO3_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/JNuwZROxCA6gRylajjtuz/0fc7d1425e78d61023b8351612340664/menpro3-us-news-badge.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/Ty7t4ovbOCiqRR28Z3uk4/26ee404c7f84aecb7a30b4f1ffbcecb8/MENPRO3_3.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/JNuwZROxCA6gRylajjtuz/0fc7d1425e78d61023b8351612340664/menpro3-us-news-badge.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3aqcPdlqT5OI8XlORhQgqu/783465dd672cbfc8972afedf0a58649f/MENPRO3_5__1_.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3nm1zbSUKBTpfbr4uyXYOu/ff2c3dfcc0561660f055e6ebe8e9d84d/MENPRO3_6__1_.png",
  },
  MENPRO6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GMRwIuDhdHgDUXeEIKA6k/806e421ca4adf50496456de0abd97673/label-men-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/AXexW6Qs1EEHSGLhOX5cX/971e20610296473040325b8f6c59cd65/MENPRO6_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6nRIML2TtnArsLzxZoJFs8/176e95c1d932637608747fb023eef137/MENPRO6_3.png",
  },
  MSR1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4yA6ajE7WFZBqMWn3E1YtN/575a7d651974895c6bf2efd379b471fc/label-men50-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1uyoyRwRiyXYx9FmJRYKeS/4366da971fd7d43f101b6784ff81ed57/MSR1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2xuGBEtEQHsrB0dOqF2LxH/aa800fe026222e68a1e2070fa893d1d4/MSR1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2SRegiGD9hi6hJodldvoVF/980da8a552db514b1931d0a8e0f0c3d2/MSR1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2ewYEkXuprrHNGtj4dn59E/0fa33ed52e8b0aca7f4d96ee368f1288/MSR1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2SRegiGD9hi6hJodldvoVF/980da8a552db514b1931d0a8e0f0c3d2/MSR1_3.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2ewYEkXuprrHNGtj4dn59E/0fa33ed52e8b0aca7f4d96ee368f1288/MSR1_4.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4OhWolXqK8i1H9vpRsv5K3/eba557343f1034e3c74e45cf33cb1fec/MSR1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3K7MpEXjjIIltzQFySiwgw/aea8b08d1f98f7113b072d19775f5d27/MSR1_8.png",
  },
  MSR3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4yA6ajE7WFZBqMWn3E1YtN/575a7d651974895c6bf2efd379b471fc/label-men50-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5qoLgRKmZ8Nng7PUIZzB1J/3af3ca945044ec7d294bcd83fa49352c/MSR3_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6P71D3FegV67uHjLIVXVrO/b7605d79f56685489a83e0e6670972e3/MSR3_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6tuQPhbsOzpIHS5WmoWg7N/84ffc5b1c54baf8bc30048c51f88a967/MSR3_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/67ka9hKg8idlNqzk1vfrfo/793b5811e4d1b327844977e76a158404/MSR3_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6tuQPhbsOzpIHS5WmoWg7N/84ffc5b1c54baf8bc30048c51f88a967/MSR3_3.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/67ka9hKg8idlNqzk1vfrfo/793b5811e4d1b327844977e76a158404/MSR3_4.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/73VRSFCPOA2hYFThohB6FK/a533ec77624df46e907bcb7a3b1063fd/MSR3_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3PZuek5kEXguX1OUaXYt7a/b93aff78aa5018b701346ced30e46b65/MSR3_8.png",
  },
  MSR6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4yA6ajE7WFZBqMWn3E1YtN/575a7d651974895c6bf2efd379b471fc/label-men50-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1mPzsujg4MgxAAzVmsbjFf/1c7debbd9a1173e4b5ecad3edd4a6f7a/MSR6_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6myFmmwa9XEnpJxBFfSP2e/728cbe02f6cabda58d93c42e712609c8/MSR6_2.png",
  },
  ADV1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41k6y9QfVPYGz3NPe5UElU/eb048fec70b838cbe96fc191d91f2e75/label-vegan-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/21CbvPfrknzgjUJDmRxC1L/d8eb5d58c170c2eab6c52ff1e0b4179d/ADV1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3g70s7Ijd11UTVDQuICp7V/250ee776c0bc3ab06ae882d18c74b2f1/ADV1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/19cZgcfOA67PzAAJMhchdW/bb75a1c76a6609fee6814c5e34318e06/ADV1_5.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6a5THIMrMC9G4Ch3p8jF4g/8dd63b6bac74f6019ef511a6ac725fd0/ADV1_6.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3CfJsRqPtamAfG60uyYfkM/604778e44253362140bed892d3f30217/ADV1_3.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1d2fQFbmMqXykseB08nXWv/b5d95dffa7b1460862412f52dab154c6/ADV1_4.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/497lyXm9XPVmeRUa4rE4th/4554a5b8a3e19ba890d4698eb03c8d97/ADV1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3oKko7k4kgXqQef6xcvANc/97449a8617b410274c1f991ed9fedea2/ADV1_8.png",
  },
  ADV3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41k6y9QfVPYGz3NPe5UElU/eb048fec70b838cbe96fc191d91f2e75/label-vegan-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7cIr4B6XoMmlHp3bcihIdX/6858e3025b0c8aded2ab8bc9bd38bea9/ADV3_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3uFWEAOWCWQ6vLG2y52Yp7/dea4f0955740d96e2e78586109d75a10/ADV3_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1SMJHevbEEI0IUjgKQDhTC/22010cd32b84ab157d828e849788c3a5/ADV3_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/67ldc65v0IxIbtQWlFU7L6/f194793a2db5e737d4c9b2114a82aa66/ADV3_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5dpnXDDolgM41oPZbBBFxh/9247ef0ff3d0a08141cabdfd4dfc409c/ADV3_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1GDVdgy1eut8pmkiWtITxb/94096b686fccc7d952cf49b9bc7ece90/ADV3_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5dpnXDDolgM41oPZbBBFxh/9247ef0ff3d0a08141cabdfd4dfc409c/ADV3_5.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1GDVdgy1eut8pmkiWtITxb/94096b686fccc7d952cf49b9bc7ece90/ADV3_6.png",
  },
  ADV6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41k6y9QfVPYGz3NPe5UElU/eb048fec70b838cbe96fc191d91f2e75/label-vegan-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/NYUhGhl6E4LyWx2NJkpte/dfff420ee2c020e469c88995e62ed710/ADV6_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1QubTT8VzBaa5EJcXWP26J/9a5736661925fa0476c2a760d4066a5f/ADV6_2.png",
  },
  BAL1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Dnrv2EF6zocSmtOhpOZ7F/483deea6c64ac0a46f981c6be2e598b2/label-balance-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4wYUcusHz8GyNh0m6PPvQC/76f9021bb643668e488683cd86a8f925/product-balance.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3SMUpWp804YgnTwGYLmZPu/b952671f4fc7a019e03bc296f8415d3b/product-balance-pills.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4PQhfdJaw8z8YQ3dcnP94L/4334f6e1ba7cb3c9b72225d5327809f1/BAL1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/RwXGiCToo66NwQtJfRxgW/6ab7faac1286129d6d775d6b33fc48a6/BAL1_6.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5bCmskwfOHLrDqp0gGp3mO/f2ab21f48b1ee8293c5804625d888199/BAL1_2__1_.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7FYlveePseNz5LxrPcT5qr/79ebcf2c44dba8e22521be817bd7d399/product-balance-badge-pills-editors-choice.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4W8wc9xUeIqJWqiYoZpyAy/177bace592519f8c4fdd34a5230d7493/nutrafol-balance-nsf.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6GuRG1JlXCz0oTluELjR8W/34f8c6ee0fa6b974c1f36d906704810f/nutrafol-balance-nsf-pills.png",
  },
  BAL3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Dnrv2EF6zocSmtOhpOZ7F/483deea6c64ac0a46f981c6be2e598b2/label-balance-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3eEgNHQKzgxtpIAfewEbJt/af89e7abd19fe3cc337374aa44bf9cf5/BAL3_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6pNSLDDyhZxbxakryal3aM/19ab901af9112c7cd06d14745d465810/BAL3_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2nl044rAYXEFFTo68GJ42X/1db2609033241b31bfdabb9aab28de1f/BAL3_5.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5BPSRfa51GWOZfSJoiawoV/8a43521472e8c2864aa0956cc3156168/BAL3_6.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/76eV9N6REYvQeLflbkU456/1de02e7d856943ebf9902f0ad29de3b2/BAL3_3.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5tYITUQ5YNPlVivmsj06R2/0516258446388adde948487eab30ee9c/BAL3_4.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2nl044rAYXEFFTo68GJ42X/1db2609033241b31bfdabb9aab28de1f/BAL3_5.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5BPSRfa51GWOZfSJoiawoV/8a43521472e8c2864aa0956cc3156168/BAL3_6.png",
  },
  BAL6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Dnrv2EF6zocSmtOhpOZ7F/483deea6c64ac0a46f981c6be2e598b2/label-balance-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7eaVkJObfSqJX089pZsKcd/62b90c19fdcd74793a2c649ab2211e94/BAL6_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Ps2VZU4vxxuFGpi8oGLSQ/286aabefe6c33741ae2af9e08ec9fce5/BAL6_3.png",
  },
  POS1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6GaFILrfOozlelhkiXhTpj/e66e5df9983e5015a9bb2184d5f4ff94/label-postpartum-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5nbbTkfSQCTUvzoQCy1mqd/dfe79ce501d9233cad73476525fc7569/product-postpartum.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2VtRHG73WC3QeuvNIb7PYR/c6a35281b03f6aec8f7ee84367ea6f64/product-postpartum-pills.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1heeSVqwT3TLMvsA5UkXbC/1201a54e50454d9da4490ed8ebcc3707/POS1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3Aj1lgETyVbWG5FIDqd2PJ/45bf24f23149a89e76d8aa58ebd4edb5/POS1_6.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1heeSVqwT3TLMvsA5UkXbC/1201a54e50454d9da4490ed8ebcc3707/POS1_3.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3Aj1lgETyVbWG5FIDqd2PJ/45bf24f23149a89e76d8aa58ebd4edb5/POS1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/623nPADjxj6OFQ6EHrRrJ9/42b4a6fc9cfb385f04aabeffc0120c00/nutrafol-postpartum-nsf.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/59VG1JBLb1lBZBhTzxl3nN/cffa0db104a011cf903fc652e422ee65/nutrafol-postpartum-nsf-pills.png",
  },
  POS3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6GaFILrfOozlelhkiXhTpj/e66e5df9983e5015a9bb2184d5f4ff94/label-postpartum-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4pfXr9DsKiMWoy9d3qufEY/c337b366d38f4e031999cdfcc711d6fb/POS3_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/23IahNyb78hMnoz8R18f3e/af36bd5bb59b4f29958de34ef27de2f6/POS3_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7CkQ1QXfq8lnG6J5iXf3zB/e2722eeb07f365b3197c3cb08240f2a1/POS3_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6CQJAAhvOTUoC4ghkbnNhT/b7146e9d0ddadb34d53f5c3bc4dc5978/POS3_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3WQ8SfTSeOYhog7ctITgqa/7b672d2f9ce188697a30c9a702831d2f/POS3_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3xvcDGOo0GINu2nPzgmAMN/f271d3d2bcc7cfa695e28a16d8e994f7/POS3_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3WQ8SfTSeOYhog7ctITgqa/7b672d2f9ce188697a30c9a702831d2f/POS3_5.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3xvcDGOo0GINu2nPzgmAMN/f271d3d2bcc7cfa695e28a16d8e994f7/POS3_6.png",
  },
  POS6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6GaFILrfOozlelhkiXhTpj/e66e5df9983e5015a9bb2184d5f4ff94/label-postpartum-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5fNBWTKOeGqll1PMtTMGSo/55015197f785965d6fb42a3b54ffdd2e/POS6_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6v7QVYJapNTwyTOSIxm1ef/265b61f1d6894f423fcf661e8a5767ac/POS6_3.png",
  },
};
